import type { TaskSummaryDTO } from '@hearth/shared';
import type { RouteObject } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';
import { TasksPage } from './TasksPage';
import { useTaskScope } from './taskScope';

export const routes: RouteObject[] = [{ path: '/tasks', element: <TasksPage /> }];

/** Sidebar badge: overdue + due-today tasks — the user's own, or everyone's for an admin/manager on "Everyone". */
export function useNavCount(): number | undefined {
  const { scope } = useTaskScope();
  const { data } = useQuery({
    queryKey: ['tasks', 'summary', 'nav', scope],
    queryFn: ({ signal }) => api.get<TaskSummaryDTO>(`/api/tasks/summary?scope=${scope}`, { signal }),
    staleTime: 60_000,
    select: (summary) => summary.overdue + summary.today,
  });
  return data;
}
